(function () {
  const overlay = document.getElementById("bmd-gummy-canvas");

  if (!overlay) return;

  let animationRunning = false;
  let initialized = false;

  function initAnimation() {
    if (initialized) return;

    initialized = true;

     var SRCS=[
    'https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_4.png?v=1781768266','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_3.png?v=1781768266','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_1.png?v=1781768265','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_5.png?v=1781768264','https://cdn.shopify.com/s/files/1/0657/7913/8630/files/image_2.png?v=1781768265'
  ];
  var IMGS=[],loaded=0;
  SRCS.forEach(function(src){
    var img=new Image();
    img.onload=function(){loaded++;if(loaded===SRCS.length)init();};
    img.src=src;IMGS.push(img);
  });
  function init(){
    var canvas=document.getElementById('bmd-gummy-canvas');
    var container=canvas.parentElement;
    function size(){canvas.width=window.innerWidth;canvas.height=window.innerHeight;}
    size();
    var W=canvas.width,H=canvas.height,ctx=canvas.getContext('2d');
    var engine=Matter.Engine.create({gravity:{x:0,y:1.9}});
    var world=engine.world;
    Matter.World.add(world,[
      Matter.Bodies.rectangle(W/2,H+40,W+400,80,{isStatic:true,friction:1.0,restitution:0}),
      Matter.Bodies.rectangle(-40,H/2,80,H*8,{isStatic:true,friction:1.0}),
      Matter.Bodies.rectangle(W+40,H/2,80,H*8,{isStatic:true,friction:1.0})
    ]);
    var GUMMY_R=50,BODY_R=GUMMY_R*0.92;
    var gummies=[],imgCounter=0;
    function makeGummy(x,y,vy){
      var body=Matter.Bodies.circle(x,y,BODY_R,{restitution:0.05,friction:0.4,frictionAir:0.012,density:0.005});
      Matter.Body.setAngle(body,Math.random()*Math.PI*2);
      Matter.Body.setVelocity(body,{x:(Math.random()-0.5)*1.2,y:vy||0});
      Matter.Body.setAngularVelocity(body,(Math.random()-0.5)*0.08);
      Matter.World.add(world,body);
      gummies.push({body:body,r:GUMMY_R,imgIdx:imgCounter%IMGS.length});
      imgCounter++;
    }
    var SPAWN_INTERVAL=45,SPAWN_BATCH=2,lastSpawn=0;
    var FILL_THRESHOLD=H*0.06;
    var bandCount=Math.max(6,Math.floor(W/(BODY_R*2.1))),bandW=W/bandCount;
    function dropIntoEmptyBands(){
      var bandTops=new Array(bandCount).fill(H);
      gummies.forEach(function(g){
        var p=g.body.position;if(p.x<0||p.x>W)return;
        var b=Math.min(bandCount-1,Math.max(0,Math.floor(p.x/bandW)));
        if(p.y<bandTops[b])bandTops[b]=p.y;
      });
      var emptyBands=[];
      for(var i=0;i<bandCount;i++){if(bandTops[i]>FILL_THRESHOLD)emptyBands.push(i);}
      if(emptyBands.length===0)return;
      for(var n=0;n<SPAWN_BATCH&&emptyBands.length>0;n++){
        var pick=Math.floor(Math.random()*emptyBands.length);
        var band=emptyBands[pick];emptyBands.splice(pick,1);
        var x=band*bandW+bandW*0.5+(Math.random()-0.5)*(bandW*0.4);
        makeGummy(x,-BODY_R-Math.random()*40,Math.random()*1.0);
      }
    }
    var mx=-9999,my=-9999;
    var REPEL_RADIUS=190,REPEL_FORCE=0.22;
    window.addEventListener('mousemove',function(e){
      var rect=canvas.getBoundingClientRect();
      mx=e.clientX-rect.left;my=e.clientY-rect.top;
    });
    Matter.Events.on(engine,'beforeUpdate',function(){
      gummies.forEach(function(g){
        var p=g.body.position,dx=p.x-mx,dy=p.y-my,d=Math.sqrt(dx*dx+dy*dy);
        if(d<REPEL_RADIUS&&d>0.5){
          var f=(1-d/REPEL_RADIUS)*(1-d/REPEL_RADIUS);
          var s=f*REPEL_FORCE*g.body.mass;
          Matter.Body.applyForce(g.body,p,{x:(dx/d)*s,y:(dy/d)*s});
        }
      });
    });
    Matter.Runner.run(Matter.Runner.create(),engine);
    function loop(ts){
      ctx.clearRect(0,0,W,H);
      if(ts-lastSpawn>SPAWN_INTERVAL){dropIntoEmptyBands();lastSpawn=ts;}
      if(gummies.length>700){
        gummies=gummies.filter(function(g){
          if(g.body.position.y>H+150){Matter.World.remove(world,g.body);return false;}
          return true;
        });
      }
      gummies.forEach(function(g){
        var pos=g.body.position;if(pos.y<-g.r*2)return;
        ctx.save();
        ctx.translate(pos.x,pos.y);ctx.rotate(g.body.angle);
        ctx.shadowColor='rgba(140,60,0,0.30)';ctx.shadowBlur=12;
        ctx.shadowOffsetX=3;ctx.shadowOffsetY=4;
        ctx.drawImage(IMGS[g.imgIdx],-g.r,-g.r,g.r*2,g.r*2);
        ctx.restore();
      });
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
    window.addEventListener('resize',size);
  }
  }

  function startAnimation() {
    initAnimation();

    animationRunning = true;
    overlay.style.display = 'block'
  }

  function stopAnimation() {
    animationRunning = false;
   overlay.style.display = 'none';
  }

  document.addEventListener("alia:popupView", startAnimation);
  document.addEventListener("alia:popupClose", stopAnimation);
})();